var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContentConcern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 12.4998V9.94817C15.833 9.0781 15.4872 8.24378 14.872 7.62846C14.2569 7.01315 13.4227 6.66717 12.5526 6.6665H7.44675C6.57682 6.66739 5.7428 7.01347 5.12782 7.62876C4.51285 8.24405 4.16719 9.07824 4.16675 9.94817V12.4998C4.16675 13.2659 4.31763 14.0244 4.61078 14.7322C4.90394 15.4399 5.33362 16.083 5.87529 16.6246C6.41697 17.1663 7.06003 17.596 7.76776 17.8891C8.47549 18.1823 9.23404 18.3332 10.0001 18.3332C10.7661 18.3332 11.5247 18.1823 12.2324 17.8891C12.9401 17.596 13.5832 17.1663 14.1249 16.6246C14.6665 16.083 15.0962 15.4399 15.3894 14.7322C15.6825 14.0244 15.8334 13.2659 15.8334 12.4998Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.08333V6.25C13.75 5.25544 13.3549 4.30161 12.6516 3.59835C11.9484 2.89509 10.9946 2.5 10 2.5C9.00544 2.5 8.05161 2.89509 7.34835 3.59835C6.64509 4.30161 6.25 5.25544 6.25 6.25V7.08333",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 11.6665H18.3334M4.16675 11.6665H1.66675M12.0834 2.9165L14.1667 1.6665M7.91675 2.9165L5.83341 1.6665M17.0834 16.6665L15.4167 15.9998M17.0834 6.6665L15.4167 7.33317M2.91675 16.6665L4.58341 15.9998M2.91675 6.6665L4.58341 7.33317M10.0001 17.9165V12.4998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_707_48",
    x1: 10.0001,
    y1: 6.6665,
    x2: 10.0001,
    y2: 18.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3612C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A095D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_707_48",
    x1: 10,
    y1: 2.5,
    x2: 10,
    y2: 7.08333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3612C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A095D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_707_48",
    x1: 10.0001,
    y1: 1.6665,
    x2: 10.0001,
    y2: 17.9165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3612C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A095D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentConcern);
export default __webpack_public_path__ + "static/media/IconContentConcern.2c43fce7de32d94a1b5c7fed403ff8d7.svg";
export { ForwardRef as ReactComponent };